import { useSyncExternalStore } from 'react';
import {
  type OutboxStorage,
  type PendingAttempt,
  parseOutbox,
  serialiseOutbox,
} from '../content/outbox';

/**
 * The outbox as a store every screen can watch: attempts that failed to reach Core, kept on
 * the device (`configureOutbox` plugs the platform's storage in at the composition root).
 * In memory only until then.
 */
let storage: OutboxStorage | undefined;
let items: readonly PendingAttempt[] = [];
const listeners = new Set<() => void>();

function publish(next: readonly PendingAttempt[]) {
  items = next;
  storage?.save(serialiseOutbox(next));
  for (const listener of listeners) listener();
}

export function configureOutbox(adapter: OutboxStorage): void {
  storage = adapter;
  items = parseOutbox(adapter.load());
  for (const listener of listeners) listener();
}

export function enqueueAttempt(item: PendingAttempt): void {
  publish([...items, item]);
}

export function replaceOutbox(next: readonly PendingAttempt[]): void {
  publish(next);
}

export function getOutbox(): readonly PendingAttempt[] {
  return items;
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** The attempts still waiting to reach Core, newest last. */
export function useOutbox(): readonly PendingAttempt[] {
  return useSyncExternalStore(subscribe, getOutbox, getOutbox);
}
